import { getRootErrorElement, getRootAppElement } from './elements';

/**
 * When there is a fatal error in the database we show a
 * plain UI with an error message inside of an element
 * and hide the main app.
 */
export function handleFatalErrorUI(error: Error) {
  const errorElement = getRootErrorElement();
  const rootlElement = getRootAppElement();

  errorElement.innerText = error.message;
  errorElement.style.display = '';

  rootlElement.style.display = 'none';
}
